module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACowAAAqMBZNxfiQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADvSURBVGiB7dexCcJQEMbx78QJgoXRjKJWlk4hdlZiIYKIWoo2DmDhDAErG2eRlK7wXCCQ8yXh8sj3qy9yfy6FAYhKEdXU4dCJx8lRHBYA+vWuhA+c3LLp/AIRVzTc0fxiPEo24rBD/csDQAJx5/h132qGVQECtyy30/8EbqWZUwUAMiyzjKeeZkgZ0FzeAdEpRXRKq9zFS3sv0BQMsMYAa13fB7/7WZV7eAv+AsEHqF6hwfVd9x65MsVMOy6QrSd175Hv+SgcCf4C7Q3g3+mKMMAaA6wxwBoDrAUfwE9KawywxgBrDLDGAGvBBxCV9AMa/yBGsZvXowAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assests/electronics.png
// module id = 117
// module chunks = 0